import React from 'react'
import { FileText } from 'lucide-react'
import styles from './MediaPreviewImage.module.scss'

interface MediaPreviewImageProps {
  url: string
  name: string
  isImage: boolean
  className?: never
}

export const MediaPreviewImage: React.FC<MediaPreviewImageProps> = ({
  url, name, isImage,
}) => {
  if (isImage) {
    return <img src={url} alt={name} className={styles.image} />
  }
  return (
    <div className={styles.placeholder}>
      <FileText className={styles.placeholderIcon} />
    </div>
  )
}
